import * as React from 'react';
import { Typography } from '../Typography/Typography';
import { cn } from '@/shared/lib/utils';

export interface ICustomCheckboxProps {
    name: string,
    value: boolean
    placeholder?: React.ReactNode;
    handleChange?: (name: string, value: string | number | boolean) => void;
    className?: string
}

export function CustomCheckbox({name, value, placeholder, className, handleChange}: ICustomCheckboxProps) {

    return (
        <div 
            className={cn('shadow-cls h-11 bg-white rounded-3xl flex justify-between items-center gap-2 px-4', className)}
            onClick={() => handleChange?.(name, !value)}
        >
            <Typography className="whitespace-nowrap truncate text[16px] font-[400]">
                {placeholder}
            </Typography>
            <div className={cn(
                'w-[34px] h-[20px] shadow-inner shadow-cls bg-slate-100 rounded-2xl flex px-1 items-center',
                (value && 'bg-green-700 justify-end')
            )}>
                <div className='h-[14px] w-[14px] rounded-full shadow-cls bg-white' />
            </div>
        </div>
    );
}
